module.exports = __webpack_public_path__ + "static/media/logo-white.304297d4.svg";